module.exports = __webpack_public_path__ + "lato-black-webfont.680164d7790acc3c1891.svg";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-black-webfont.svg
// module id = ../../../../../resources/fonts/lato-black-webfont.svg
// module chunks = styles